import React, { useState } from 'react';
import { Tooltip, ButtonIcon, Text } from '@blueprint/ui';

export const HoverTip = ({ content, ariaLabel, id }) => {
    const [hover, setHover] = useState(false);
    return (
        <Tooltip
            role='tooltip'
            id={id}
            placement='auto'
            tooltip={<Text style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>{content}</Text>}
            trigger={['hover', 'focus', 'click']}
            onMouseEnter={() => {
                setHover(true);
            }}
            onMouseLeave={() => {
                setHover(false);
            }}
        >
            <ButtonIcon isActive={hover} name='Help' aria-label={ariaLabel} aria-describedby={id} />
        </Tooltip>
    );
};
